import React, { useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { Box, Button } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import useToken from '../../../helpers/useTokens'
import { getStatusOpt } from '../constants'
import { navigation3 } from '../../../common/helper'
import { useAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { PostRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { RenderTable } from '../../Reports/analysisReport/summmaryTable'
import { getCrewTypeList, getHeaders } from './constants'
import { CreateUpdateCrew } from './createUpdateCrew'
import EditIcon from '@mui/icons-material/Edit';
import QRDownloadIcon from '../../../../assests/QRDownloadIcon.png'
import { encrypt } from '../../../common/loginDecode'
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { useTranslation } from '../../../../i18n/I18nProvider'
export const CrewMaster = () => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const crewTypeList = getCrewTypeList(translations)
    const statusOpt = getStatusOpt(translations)
    const headers = getHeaders(translations)
    const { loginData } = useToken()
    const [creType, setCrewType] = useState(crewTypeList[0])
    const [isEdit,setIsEdit]=useState(false)
    const [modal, setModal] = useAtom(modalAtom)
    const [, setLoader] = useAtom(globalLoaderAtom)
    const [, setAlert] = useAtom(alertAtom)
    const [tableData, setTableData] = useState([])
    const [showTable, setShowTable] = useState(false)
    const [status, setStatus] = useState({ name: bum.active || 'Active', id: 1 })
    const [crewData,setCrewData]=useState({})
    const handleDownloadQR = async (item) => {
        try {
            const qrString = `${item.DriverConductorID}^^^^${item.DriverConductorCode}^^^^${item.UserID}^^^^${item.DriverConductorName}^^^^${item.CrewTypeID}`;
            const updateQRString = encrypt(qrString)
            const qrDataUrl = await QRCode.toDataURL(updateQRString, { width: 200 });
            const pdf = new jsPDF();
            pdf.setFontSize(14);
            pdf.text(bum.crewQrCodeTrail || `Crew QR Code `, 30, 20);
            pdf.text(`${item.DriverConductorName}`, 30, 30);
            pdf.addImage(qrDataUrl, "PNG", 20, 35, 100, 100);
            pdf.save(`QR_${item.DriverConductorName}.pdf`);
        } catch (err) {
            console.error("QR generation failed:", err);
        }
    };
    const handleEditClick = async (item) => {
        setCrewData({})
        const body = {
            intUserID: 0,
            intDriverConductorID: item.DriverConductorID,
            intCompanyID: loginData.intCompanyID,
            intBusID: 0,
            intIsDriver: 0,
            intStateID: 0,
            intCityID: 0,
            intIsActive: status?.id,
            CrewTypeID: creType?.id || 0,
        }
        try {
            const res = await PostRequest(urls.getDriverList, body)
            if (res.status === "Success") {
                const list = res?.Data || []
                setCrewData(list?.[0] || {})
            } else {
                setAlert({ show: true, msg: res.ErrMessage })
            }
        } catch (error) {
            console.log('Error:', error)
        } finally {
            setIsEdit(true)
            setLoader(false)
            setModal("createUpdateCrew")
        }


    }
    const onLoad = async () => {
        setLoader(true)
        const body = {
            intUserID: 0,
            intDriverConductorID: 0,
            intCompanyID: loginData.intCompanyID,
            intBusID: 0,
            intIsDriver: 0,
            intStateID: 0,
            intCityID: 0,
            intIsActive: status?.id,
            CrewTypeID: creType?.id || 0,
        }
        try {
            const res = await PostRequest(urls.getDriverList, body)
            if (res.status === "Success") {
                const list = res?.Data || []
                const tableData = list.map((item, index) => ({
                    sn: index + 1,
                    CrewType: crewTypeList.find((x) => x.id === item.CrewTypeID)?.name || "",
                    Status: item.IsActive ? (bum.active || 'Active') : (bum.inActive || 'InActive'),
                    edit:
                        <span
                            id={`editBtn-${index}`}
                            tabIndex={0}
                            style={{
                                display: 'flex',
                                color: '#007bfd',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                width: '52px',
                                padding: '2px 4px',
                                marginLeft: '-6px',
                            }}
                            onClick={() => {
                                handleEditClick(item)
                            }}
                        >
                            <EditIcon sx={{ marginRight: '3px' }} />
                        </span>,
                    downloadQr: <span
                        id={`Edit-${index}`} tabIndex={0}
                        style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                        onClick={() => handleDownloadQR(item)}
                    >
                        <img src={QRDownloadIcon} alt="QR" style={{ height: '25px', width: '68px' }} />
                    </span>,
                    ...item,

                }))
                setTableData(tableData)
            } else {
                setAlert({ show: true, msg: res.ErrMessage })
            }
        } catch (error) {
            console.log('Error:', error)
        } finally {
            setLoader(false)
            setShowTable(true)
        }
    }
    const handleCreateNewCrew=()=>{
        setCrewData({})
        setIsEdit(false)
        setModal("createUpdateCrew")
    }
    return (
        <>
            <Box sx={sx.reportFlex} className='reportButton'>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    <DropDownOA
                        id="UMCompanyName"
                        label={bum.companyName || cs.companyName || 'Company Name'}
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    <DropDownOA
                        id={"UMStatus"}
                        data={crewTypeList}
                        width="100%"
                        noCross={true}
                        searchPlaceholder={bum.searchCrewTypeLower || `Search crew Type`}
                        label={bum.selectCrewType || "Select Crew Type"}
                        dataKey={`name`}
                        idKey={`id`}
                        nextId={"UMLoad"}
                        prevId={"UMCreateNewMaster"}
                        defaultvalue={creType?.name}
                        onSelect={(value) => setCrewType(value)}
                    />
                </Item>
                <Item sx={sx.itemsx} style={{ width: "250px" }}>
                    <DropDownOA
                        id={"UMStatus"}
                        defaultvalue={status?.name || ""}
                        data={[{ name: bum.showAll || "Show All", id: -1 }, ...statusOpt] || []}
                        width="100%"
                        noCross={true}
                        searchPlaceholder={bum.searchStatus || `Search Status`}
                        label={bum.status || cs.status || "Status"}
                        dataKey={`name`}
                        idKey={`id`}
                        nextId={"UMLoad"}
                        prevId={"UMCreateNewMaster"}
                        onSelect={(value) => setStatus(value)}
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMCreateNewMaster", "UMStatus", () => { })}>
                    <Button id="UMLoad" variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        onClick={onLoad}
                    >
                        {bum.load || 'LOAD'}
                    </Button>
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMStatus", "UMLoad", () => { })}>
                    <Button id="UMCreateNewMaster" variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={handleCreateNewCrew}>
                        {bum.createNewCrewUpper || 'CREATE NEW CREW'}
                    </Button>
                </Item>
            </Box>
            <Box sx={sx.reportFlex}>
                {showTable ? <RenderTable header={headers} data={tableData} /> : <></>}

            </Box>

            {modal === "createUpdateCrew" ? <CreateUpdateCrew crewData={crewData} setCrewData={setCrewData} isEdit={isEdit} /> : <></>}
        </>

    )
}
